import React, {Fragment} from "react";
import ChannelCard from "../../Utilities/ChannelCard";
import logoCustomerIo from "../../../../../images/logos/logo_customerio.svg";
import CustomerIoSetupModal from "./CustomerIoSetupModal";
import useCustomerIoSetup from "./useCustomerIoSetup";

export default function CustomerIoProvider(){
    const { initiateCustomerIoSetup, customerIoSetupOpen, handleCustomerIoSetupOpen, handleCustomerIoSetupClose } = useCustomerIoSetup()

    return(
        <Fragment>
            <ChannelCard
                icon={logoCustomerIo}
                label={'customer.io'}
                description={'Send personalized winback messages'}
                onClick={initiateCustomerIoSetup}
            />

            <CustomerIoSetupModal
                open={customerIoSetupOpen}
                handleOpen={handleCustomerIoSetupOpen}
                handleClose={handleCustomerIoSetupClose}
            />
        </Fragment>
    )
}